import { normaliserLibelle } from '@admin-pmvb/core'

// De quel logo de src/logos un nom de fournisseur ou un libellé de relevé relève : mots de la
// marque, sur le texte normalisé (majuscules, sans accents). Dans l'ordre : le premier gagne, car
// un libellé peut en citer deux (« DARTY.COM APPLE PAY », « AMAZON AMEX PRIME VIDEO »).
const MARQUES: readonly (readonly [RegExp, string])[] = [
  [/\bAMAZON\b/, 'amazon'],
  [/\bDARTY\b/, 'darty'],
  [/\bAPPLE\b(?! PAY)/, 'apple'],
  [/\bAMERICAN EXPRESS\b|\bAMEX\b/, 'amex'],
  [/\bBOUYGUES\b|\bBBOX\b/, 'bouygues'],
  [/CREDIT AGRICOLE|\bCRCA\b|\bPACIFICA\b/, 'credit_agricole'],
  [/\bEDF\b|ELECTRICITE DE FRANCE/, 'edf'],
  [/\bENGIE\b/, 'engie_pro'],
  [/EAUX DE VIENNE/, 'eaux_de_vienne'],
  [/\bGOOGLE ?\*?ADS/, 'google_ads'],
  [/\bGOOGLE\b/, 'google'],
  [/\bADOBE\b/, 'adobe'],
  [/\bANTHROPIC\b|\bCLAUDE\.AI\b/, 'anthropic'],
  [/\bOPENAI\b|\bCHATGPT\b/, 'openai'],
  [/\bUBER\b/, 'uber'],
  [/\bULYS\b|AUTOROUTES DU SUD/, 'ulys'],
  [/\bTIIME\b/, 'tiime'],
  [/\bDOUGS\b/, 'dougs'],
  [/\bNUMBR\b/, 'numbr'],
  [/\bAON\b/, 'aon'],
  [/\bAMELI\b|ASSURANCE MALADIE|\bCPAM\b/, 'ameli'],
  [/\bSUPABASE\b/, 'supabase'],
  [/\bWIX\b/, 'wix'],
  [/\bFLY\.IO\b/, 'fly'],
  [/\bELEVEN ?LABS\b/, 'elevenlabs'],
  [/\bELEST\.?IO\b/, 'elestio'],
  [/\bMISTRAL\b/, 'mistral'],
  [/\bRUNWAY\b/, 'runway'],
  [/\bSPEECHMATICS\b/, 'speechmatics'],
  [/\bSALESFORCE\b/, 'salesforce'],
  [/\bTRAINLINE\b/, 'trainline'],
  [/\bG7\b/, 'g7'],
  [/\bQALIMO\b/, 'qalimo'],
  [/\bSPOTIFY\b/, 'spotify'],
  [/\bNETFLIX\b/, 'netflix'],
  [/\bDISNEY\b/, 'disney'],
  [/\bDECATHLON\b/, 'decathlon'],
  [/\bAIR UP\b/, 'airup'],
  [/\bHISCOX\b/, 'hiscox'],
  [/\bDGFIP\b|DIRECTION GENERALE DES FINANCES|SERVICE DES IMPOTS/, 'dgfip'],
]

/** Les clés que la table peut rendre : chacune a son fichier (vérifié par le test). */
export const CLES_MARQUES: readonly string[] = MARQUES.map(([, cle]) => cle)

export function cleLogoDeNom(texte: string | null | undefined): string | null {
  if (!texte) return null
  const normalise = normaliserLibelle(texte)
  return MARQUES.find(([motif]) => motif.test(normalise))?.[1] ?? null
}
